import {useTranslation} from 'react-i18next';
import {tokens, Helper} from '@tickchak/react-share/app';
import CheckMark from '../../../../../../assets/icons/checkMark';
import * as css from './SubscriptionTypeCard.css';

interface SubscriptionTypeCardProps {
    type: {
        id: string;
        label: string;
        icon: string;
        isActive: boolean;
    };
    isSelected: boolean;
    onSelect: () => void;
}

function SubscriptionTypeCard({type, isSelected, onSelect}: SubscriptionTypeCardProps) {
    const {t} = useTranslation('subscriptions');

    return (
        <css.typeCard
            type="button"
            data-cy={`subscription-type-${type.id}-series-btn`}
            className={`${isSelected ? 'selected' : ''} ${!type.isActive ? 'disabled' : ''}`}
            onClick={onSelect}
        >
            <css.helperWrapper>
                <Helper
                    title={t(`${type.id}HelperTitle`)}
                    content={t(`${type.id}HelperContent`)}
                    size='small'
                /> 
            </css.helperWrapper>
            <css.typeLabel>{type.label}</css.typeLabel>
            <css.typeIconWrapper $icon={type.icon} className={!type.isActive ? 'disabled' : ''} />
            <css.checkMarkWrapper>
                {isSelected ? (
                    <css.successCheckMark>
                        <CheckMark color={tokens.color.state?.success?.border || 'var(--color-state-success-border)'} width={10} height={10} />
                    </css.successCheckMark>
                ) : (
                    <css.checkMark $active={type.isActive} />
                )}
            </css.checkMarkWrapper>
        </css.typeCard>
    );
}

export default SubscriptionTypeCard;

